export const mergeServiceIds = (
  assetServiceIds = [],
  entityServiceIds = []
) => [...new Set([...assetServiceIds, ...entityServiceIds].filter(Boolean))];

export const loadAssetServices = async (apiService, asset) => {
  const entity = asset?.entity_id
    ? await apiService.getEntity(asset.entity_id)
    : null;
  const serviceIds = mergeServiceIds(asset?.service_ids, entity?.service_ids);

  const services = await Promise.all(
    serviceIds.map((serviceId) => apiService.getServicesById(serviceId))
  );

  return services.filter(Boolean);
};
